import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { BONUSES } from '../data/content';
export function BonusesSection() {
  return <section className="border-y border-ink-700/60 bg-ink-900 py-10 sm:py-12" style={{
    paddingBottom: "8px"
  }} data-id="element-19" data-mp="vsw8y0tmyjd2">
      <div className="mx-auto max-w-content px-5" data-id="element-20" data-mp="qta0e4or5ral">
        <SectionHeading eyebrow="🎁 INCLUDED TODAY" title="4 free" highlight="bonuses" data-id="element-21" data-mp="qsi38pfibli7" />

        <div className="mt-6 grid gap-3 md:grid-cols-2" data-id="element-22" data-mp="14rzwpi3qzmxw">
          {BONUSES.map(bonus => <article key={bonus.label} className="flex h-full gap-4 rounded-2xl border border-ink-700 bg-ink-850 p-4" data-id="element-23" data-mp="ztg5p3aarkyo">
              <img src={bonus.image} alt={`${bonus.title} ebook cover`} className="h-[136px] w-[104px] shrink-0 rounded-lg bg-ink-800 object-cover" width={208} height={272} loading="lazy" data-id="element-24" data-mp="1eiufudlp66f4" />
              <div className="flex min-w-0 flex-col" data-id="element-25" data-mp="1nklnvp3pmpc5">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-26" data-mp="1jiqowr994o1j">
                  <span className="inline-flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-[0.18em] text-lime-400" data-id="element-27" data-mp="1jgnoreedxej3">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-28" data-mp="3tr5go3y1w9th" />
                    {bonus.label}
                  </span>
                  <span className="text-xs font-bold text-white/40" data-id="element-29" data-mp="2kb00xqv4wra">
                    <s data-id="element-30" data-mp="7lqlgqwyd5a7">{bonus.value}</s>
                    <span className="ml-2 rounded-full bg-lime-500 px-2 py-0.5 text-ink-950" data-id="element-31" data-mp="7im9369c338g">
                      FREE
                    </span>
                  </span>
                </div>
                <h3 className="mt-2 text-base font-extrabold uppercase leading-tight text-white" data-id="element-32" data-mp="gjkjc6ad86zh">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-sm leading-snug text-white/60" data-id="element-33" data-mp="qbq9rbkyygck">{bonus.body}</p>
              </div>
            </article>)}
        </div>

        <p className="mt-5 text-center text-base font-extrabold text-white sm:text-lg" data-id="element-34" data-mp="vc4hesinroa2">
          Total bonus value: <s className="text-white/40" data-id="element-35" data-mp="107a1rmwewuw1">USD 96</s>{' '}
          <span className="text-lime-400" data-id="element-36" data-mp="akfrktndaubh">→ FREE with your pack</span>
        </p>
      </div>
    </section>;
}